export const permissionsForcedModeController = {
  status: false,
  enable() {
    this.status = true
  },
  disable() {
    this.status = false
  }
}

// Allows to see/set all features on any account
// This is extremely useful when testing, especially for lower permission user testing.
;(window as any).permissionsForcedMode = permissionsForcedModeController
